import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface DebugState {
  skipReservation: boolean;
  toggleSkipReservation: () => void;
  kbEventDateIndex: number | null;
  setKbEventDateIndex: (index: number | null) => void;
}

export const useDebugStore = create<DebugState>()(
  persist(
    (set) => ({
      skipReservation: false,
      toggleSkipReservation: () =>
        set((state) => ({ skipReservation: !state.skipReservation })),
      kbEventDateIndex: null,
      setKbEventDateIndex: (index) => set({ kbEventDateIndex: index }),
    }),
    { name: 'wello-debug' },
  ),
);
